import { useState } from 'react';
import styles from './EventPage.module.css';
import bgImage from '../../../assets/images/event/background.jpg';
import bgImagePhone from '../../../assets/images/event/background-phone.jpg';
import TitleSection from './components/TitleSection';
import SloganSection from './components/SloganSection';
import CardSection from './components/CardSection';
import StrengthsSection from './components/StrengthsSection';
import BenefitSection from './components/BenefitSection';
import RequestSection from './components/RequestSection';
import Footer from './components/Footer';
import QuickMenu from './components/QuickMenu';
import FlowModal from './components/consent/FlowModal';

function EventPage() {
  const [isConsentOpen, setIsConsentOpen] = useState(false);

  return (
    <>
      <div className={styles.bg} style={{ backgroundImage: `url(${bgImage})` }} />
      <div className={styles.bgMobile} style={{ backgroundImage: `url(${bgImagePhone})` }} />
      <div className={styles.page}>
        <TitleSection />
        <SloganSection />
        <CardSection />
        <StrengthsSection />
        <BenefitSection />
        <RequestSection />
        <Footer onConsentClick={() => setIsConsentOpen(true)} />
        <QuickMenu onConsentClick={() => setIsConsentOpen(true)} />
      </div>
      {isConsentOpen && <FlowModal onClose={() => setIsConsentOpen(false)} />}
    </>
  );
}

export default EventPage;
